import { lazier } from '@shared/components';

export const MessagingPage = lazier(() => import('./MessagingPage'));

export const BalanceMessagingPage = lazier(() =>
  import('./BalanceMessagingPage'),
);
